import { useFormContext } from 'react-hook-form'
import { useCalculatedAmounts } from 'src/hooks/useCalculatedAmounts'
import { InvoiceFormInputs } from '../InvoiceEditForm'

export const Tax: React.FC = () => {
  const { watch } = useFormContext<InvoiceFormInputs>()
  const { calculated_amount } = useCalculatedAmounts(
    watch('items'),
    watch('taxSettings')
  )
  const items = watch('items')

  const baseYPosition =
    items.length > 16
      ? 60 + items.slice(16, 30).length * 24 + 24
      : items.length > 12
      ? 60
      : 352.5 + Math.max(0, items.length - 4) * 24
  return (
    <>
      <rect width="56" height="24" x="36" y={baseYPosition} fill="#F8F8F8" />
      <rect width="44" height="24" x="172" y={baseYPosition} fill="#F8F8F8" />
      <rect
        width="56"
        height="24"
        x="36"
        y={baseYPosition + 24}
        fill="#F8F8F8"
      />
      <rect
        width="44"
        height="24"
        x="172"
        y={baseYPosition + 24}
        fill="#F8F8F8"
      />
      <text
        x="62"
        y={baseYPosition + 16}
        fill="#0D0D0D"
        fontSize={'10px'}
        fontWeight="bold"
        textAnchor="middle"
      >
        10%対象
      </text>
      <text
        x="62"
        y={baseYPosition + 24 + 16}
        fill="#0D0D0D"
        fontSize={'10px'}
        fontWeight="bold"
        textAnchor="middle"
      >
        8%対象
      </text>
      <text
        x="194"
        y={baseYPosition + 16}
        fill="#0D0D0D"
        fontSize={'10px'}
        fontWeight="bold"
        textAnchor="middle"
      >
        消費税
      </text>
      <text
        x="194"
        y={baseYPosition + 24 + 16}
        fill="#0D0D0D"
        fontSize={'10px'}
        fontWeight="bold"
        textAnchor="middle"
      >
        消費税
      </text>
      <line
        x1="36"
        y1={baseYPosition + 24.5}
        x2="296"
        y2={baseYPosition + 24.5}
        stroke="#EAEAEA"
      />
      <text
        x="150"
        y={baseYPosition + 16}
        fill="#0D0D0D"
        fontSize={'10px'}
        textAnchor={'end'}
      >
        ¥
        {(
          calculated_amount?.calculated_amount
            .amount_excluding_tax_of_tax_rate_10 ?? 0
        ).toLocaleString()}
      </text>
      <text
        x="275"
        y={baseYPosition + 16}
        fill="#0D0D0D"
        fontSize={'10px'}
        textAnchor={'end'}
      >
        ¥
        {(
          calculated_amount?.calculated_amount.tax_amount_of_tax_rate_10 ?? 0
        ).toLocaleString()}
      </text>
      <text
        x="150"
        y={baseYPosition + 24 + 16}
        fill="#0D0D0D"
        fontSize={'10px'}
        textAnchor={'end'}
      >
        ¥
        {(
          calculated_amount?.calculated_amount
            .amount_excluding_tax_of_tax_rate_8 ?? 0
        ).toLocaleString()}
      </text>
      <text
        x={275}
        y={baseYPosition + 24 + 16}
        fill="#0D0D0D"
        fontSize={'10px'}
        textAnchor={'end'}
      >
        ¥
        {(
          calculated_amount?.calculated_amount.tax_amount_of_tax_rate_8 ?? 0
        ).toLocaleString()}
      </text>
      <rect x="36" y={baseYPosition} width="260" height="48" stroke="#EAEAEA" />
    </>
  )
}
